var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pencil hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u05E2\\u05DE\\u05D5\\u05D3-\\u05DC\\u05E7\\u05D7\\u05D9\\u05DD----\\u05DE\\u05DE\\u05EA\\u05D9\\u05DF-\\u05DC\\u05D0\\u05D9\\u05E9\\u05D5\\u05E8-tooltip",
    transform: "translate(-866.000000, -126.000000)",
    fill: "#0077C6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(700.000000, 122.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/pencil",
    transform: "translate(167.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pencil-hover",
    transform: "translate(-0.947368, -0.947368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3056866,14.4230555 L26.9882463,15.7407349 C26.7422322,15.9867937 26.3404474,15.9867937 26.0938584,15.7407349 L22.5180313,12.1636837 C22.2714424,11.91705 22.2714424,11.5151923 22.5180313,11.2685586 L23.8354716,9.95087918 C24.6235216,9.16268613 25.908773,9.16268613 26.696823,9.95087918 L28.3056866,11.5606097 C29.0937366,12.3493776 29.0937366,13.6342875 28.3056866,14.4230555 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2833913,17.4458994 L15.7175795,27.0134477 C15.3198183,27.4112811 14.8663016,27.6400928 14.3104706,27.7251786 L10.5317393,28.3012321 C10.1954816,28.3523986 9.9040583,28.0614973 9.95521545,27.7251786 L10.5346133,23.9480609 C10.6196836,23.3927039 10.8490285,22.9402546 11.2462149,22.5424212 L20.8131763,12.974298 C21.0591904,12.7282392 21.4609752,12.7282392 21.7075642,12.974298 L25.2833913,16.5513492 C25.5294054,16.7979829 25.5294054,17.1992657 25.2833913,17.4458994 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9473684,0 C8.48302579,0 0,8.48302579 0,18.9473684 C0,29.411711 8.48302579,37.8947368 18.9473684,37.8947368 C29.411711,37.8947368 37.8947368,29.411711 37.8947368,18.9473684 C37.8947368,8.48302579 29.411711,0 18.9473684,0 Z M18.9473684,1.89473684 C28.3652768,1.89473684 36,9.52946006 36,18.9473684 C36,28.3652768 28.3652768,36 18.9473684,36 C9.52946006,36 1.89473684,28.3652768 1.89473684,18.9473684 C1.89473684,9.52946006 9.52946006,1.89473684 18.9473684,1.89473684 Z",
    id: "Oval"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilHover);
export default __webpack_public_path__ + "static/media/pencil_hover.89d9a1b155dfd9d6478d8f8873f5b5ab.svg";
export { ForwardRef as ReactComponent };